/* eslint-disable no-undef */
import englishMessages from 'ra-language-english';

const countries = {
	AX: 'Aaland Islands',
	AF: 'Afghanistan',
	AL: 'Albania',
	DZ: 'Algeria',
	AS: 'American Samoa',
	AD: 'Andorra',
	AO: 'Angola',
	AI: 'Anguilla',
	AQ: 'Antarctica',
	AG: 'Antigua and Barbuda',
	AR: 'Argentina',
	AM: 'Armenia',
	AW: 'Aruba',
	AU: 'Australia',
	AT: 'Austria',
	AZ: 'Azerbaijan',
	BS: 'Bahamas',
	BH: 'Bahrain',
	BD: 'Bangladesh',
	BB: 'Barbados',
	BY: 'Belarus',
	BE: 'Belgium',
	BZ: 'Belize',
	BJ: 'Benin',
	BM: 'Bermuda',
	BT: 'Bhutan',
	BO: 'Bolivia',
	BA: 'Bosnia and Herzegowina',
	BW: 'Botswana',
	BV: 'Bouvet Island',
	BR: 'Brazil',
	IO: 'British Indian Ocean Territory',
	BN: 'Brunei Darussalam',
	BG: 'Bulgaria',
	BF: 'Burkina Faso',
	BI: 'Burundi',
	KH: 'Cambodia',
	CM: 'Cameroon',
	CA: 'Canada',
	CV: 'Cape Verde',
	KY: 'Cayman Islands',
	CF: 'Central African Republic',
	TD: 'Chad',
	CL: 'Chile',
	CN: 'China',
	CX: 'Christmas Island',
	CC: 'Cocos (keeling) Islands',
	CO: 'Colombia',
	KM: 'Comoros',
	CD: 'Democratic Republic Of Congo (was Zaire)',
	CG: 'Republic Of Congo',
	CK: 'Cook Islands',
	CR: 'Costa Rica',
	CI: "Cote D'ivoire",
	HR: 'Croatia',
	CU: 'Cuba',
	CY: 'Cyprus',
	CZ: 'Czech Republic',
	DK: 'Denmark',
	DJ: 'Djibouti',
	DM: 'Dominica',
	DO: 'Dominican Republic',
	EC: 'Ecuador',
	EG: 'Egypt',
	SV: 'El Salvador',
	GQ: 'Equatorial Guinea',
	ER: 'Eritrea',
	EE: 'Estonia',
	ET: 'Ethiopia',
	FK: 'Falkland Islands (Malvinas)',
	FO: 'Faroe Islands',
	FJ: 'Fiji',
	FI: 'Finland',
	FR: 'France',
	GF: 'French Guiana',
	PF: 'French Polynesia',
	TF: 'French Southern Territories',
	GA: 'Gabon',
	GM: 'Gambia',
	GE: 'Georgia',
	DE: 'Germany',
	GH: 'Ghana',
	GI: 'Gibraltar',
	GR: 'Greece',
	GL: 'Greenland',
	GD: 'Grenada',
	GP: 'Guadeloupe',
	GU: 'Guam',
	GT: 'Guatemala',
	GN: 'Guinea',
	GW: 'Guinea-bissau',
	GY: 'Guyana',
	HT: 'Haiti',
	HM: 'Heard And Mc Donald Islands',
	HN: 'Honduras',
	HK: 'Hong Kong',
	HU: 'Hungary',
	IS: 'Iceland',
	IN: 'India',
	ID: 'Indonesia',
	IR: 'Islamic Republic Of Iran',
	IQ: 'Iraq',
	IE: 'Ireland',
	IL: 'Israel',
	IT: 'Italy',
	JM: 'Jamaica',
	JP: 'Japan',
	JO: 'Jordan',
	KZ: 'Kazakhstan',
	KE: 'Kenya',
	KI: 'Kiribati',
	KP: "Democratic People's Republic of Korea",
	KR: 'Korea, Republic of',
	KW: 'Kuwait',
	KG: 'Kyrgyzstan',
	LA: "Lao People's Democratic Republic",
	LV: 'Latvia',
	LB: 'Lebanon',
	LS: 'Lesotho',
	LR: 'Liberia',
	LY: 'Libyan Arab Jamahiriya',
	LI: 'Liechtenstein',
	LT: 'Lithuania',
	LU: 'Luxembourg',
	ME: 'Montenegro',
	MO: 'Macau',
	MK: 'The Former Yugoslav Republic of Macedonia',
	MG: 'Madagascar',
	MW: 'Malawi',
	MY: 'Malaysia',
	MV: 'Maldives',
	ML: 'Mali',
	MT: 'Malta',
	MH: 'Marshall Islands',
	MQ: 'Martinique',
	MR: 'Mauritania',
	MU: 'Mauritius',
	YT: 'Mayotte',
	MX: 'Mexico',
	FM: 'Micronesia, Federated States of',
	MD: 'Republic of Moldova',
	MC: 'Monaco',
	MN: 'Mongolia',
	MS: 'Montserrat',
	MA: 'Morocco',
	MZ: 'Mozambique',
	MM: 'Myanmar',
	NA: 'Namibia',
	NR: 'Nauru',
	NP: 'Nepal',
	NL: 'Netherlands',
	AN: 'Netherlands Antilles',
	NC: 'New Caledonia',
	NZ: 'New Zealand',
	NI: 'Nicaragua',
	NE: 'Niger',
	NG: 'Nigeria',
	NU: 'Niue',
	NF: 'Norfolk Island',
	MP: 'Northern Mariana Islands',
	NO: 'Norway',
	OM: 'Oman',
	PK: 'Pakistan',
	PW: 'Palau',
	PS: 'Palestinian Territory, Occupied',
	PA: 'Panama',
	PG: 'Papua New Guinea',
	PY: 'Paraguay',
	PE: 'Peru',
	PH: 'Philippines',
	PN: 'Pitcairn',
	PL: 'Poland',
	PT: 'Portugal',
	PR: 'Puerto Rico',
	QA: 'Qatar',
	RE: 'Reunion',
	RO: 'Romania',
	RU: 'Russian Federation',
	RW: 'Rwanda',
	SH: 'Saint Helena',
	KN: 'Saint Kitts And Nevis',
	LC: 'Saint Lucia',
	PM: 'Saint Pierre And Miquelon',
	VC: 'Saint Vincent And The Grenadines',
	WS: 'Samoa',
	SM: 'San Marino',
	ST: 'Sao Tome And Principe',
	SA: 'Saudi Arabia',
	SN: 'Senegal',
	CS: 'Serbia And Montenegro',
	SC: 'Seychelles',
	SL: 'Sierra Leone',
	SG: 'Singapore',
	SK: 'Slovakia',
	SI: 'Slovenia',
	SB: 'Solomon Islands',
	SO: 'Somalia',
	ZA: 'South Africa',
	GS: 'South Georgia and the South Sandwich Islands',
	ES: 'Spain',
	LK: 'Sri Lanka',
	SD: 'Sudan',
	SR: 'Suriname',
	SJ: 'Svalbard And Jan Mayen Islands',
	SZ: 'Swaziland',
	SE: 'Sweden',
	CH: 'Switzerland',
	SY: 'Syrian Arab Republic',
	TW: 'Taiwan',
	TJ: 'Tajikistan',
	TZ: 'United Republic of Tanzania',
	TH: 'Thailand',
	TL: 'Timor-Leste',
	TG: 'Togo',
	TK: 'Tokelau',
	TO: 'Tonga',
	TT: 'Trinidad and Tobago',
	TN: 'Tunisia',
	TR: 'Turkey',
	TM: 'Turkmenistan',
	TC: 'Turks And Caicos Islands',
	TV: 'Tuvalu',
	UG: 'Uganda',
	UA: 'Ukraine',
	AE: 'United Arab Emirates',
	GB: 'United Kingdom',
	US: 'United States',
	UM: 'United States Minor Outlying Islands',
	UY: 'Uruguay',
	UZ: 'Uzbekistan',
	VA: 'Vatican City State (Holy See)',
	VE: 'Venezuela',
	VN: 'Viet Nam',
	VG: 'Virgin Islands (British)',
	VI: 'Virgin Islands (US)',
	WF: 'Wallis And Futuna Islands',
	EH: 'Western Sahara',
	YE: 'Yemen',
	ZM: 'Zambia',
	ZW: 'Zimbabwe'
};
const countriesForSelection = Object.keys(countries).map(key => {
	return { id: key, name: countries[key] };
});

const languages = {
	DE: 'German',
	EN: 'English',
	ES: 'Spanish',
	FI: 'Finnish',
	FR: 'French',
	ID: 'Indonesia',
	IT: 'Italian',
	NL: 'Dutch',
	TH: 'Thai',
	PL: 'Polish',
	CZ: 'Czech',
	RU: 'Russian'
};
const languagesForSelection = Object.keys(languages).map(key => {
	return { id: key, name: languages[key] };
});

export { countriesForSelection, languagesForSelection };

const messages = {
	...englishMessages,
	coreWalletAdmin: {
		common: {
			confirmButton: 'Confirm',
			cancelButton: 'Cancel',
			saveButton: 'Save',
			gender: {
				male: 'Male',
				female: 'Female',
				unknown: 'Unknown'
			},
			labels: {
				entityId: 'ID:',
				goToIdButton: 'Go to ID',
				goToTypeButton: 'Go to %{type}'
			},
			adminApprovalRequired: 'An additional administrator approval is required. The action has been stored and will be finalized once it is approved by a second administrator.',
		},
		menu: {
			wallets: 'Wallet',
			users: 'User',
			transactions: 'Transactions',
			config: 'Config',
			accounting: 'Accounting',
			payment: 'Payment'
		},
		dashboard: {
			unprocessedIdDocuments: 'Unprocessed ID Documents',
			usersOnWatchlist: 'Users on watch list'
		},
		wallets: {
			list: {
				lockDialog: {
					title: 'Lock Wallets',
					prompt: 'Please specify a lock reason:'
				}
			}
		},
		countries
	},
	resources: {
		users: {
			name: 'Users',
			tabs: {
				details: 'Details',
				wallets: 'Wallets',
				addresses: 'Addresses',
				idDocuments: 'ID documents'
			},
			labels: {
				updateRoles: 'Update Roles',
				addToWatchList: 'Add To Watchlist',
				removeFromWatchList: 'Remove from Watchlist',
				updateVerificationLevel: 'Update Verification Level',
				goToUserId: 'Go To User ID'
			},
			aside: {
				id: 'ID',
				creationDateTime: 'Created',
				status: 'Status'
			},
			notifications: {
				roles: 'Roles updated.',
				updateVerificationLevel: 'Verification Level updated.',
				addedToWatchList: 'User added to Watchlist.',
				removedFromWatchList: 'User is removed from Watchlist.'
			},
			filter: {
				createdFrom: 'Created From',
				createdTo: 'Created To',
				emailLike: 'Email',
				phoneNumberLike: 'Phone Number',
				nationCodeList: 'Nation',
				userStatusList: 'User Status',
				userVerificationLevels: 'Verification Level',
				firstNameLike: 'First Name',
				lastNameLike: 'Last Name',
				dateOfBirthFrom: 'Date Of Birth From',
				dateOfBirthTo: 'Date Of Birth To',
				birthPlaceLike: 'Birth Place',
				birthCountry: 'Birth Country',
				primaryAddressCityLike: 'City',
				primaryAddressZip: 'Zip',
				primaryAddressCountry: 'Country',
				registrationSource: 'Registration Source',
				isOnWatchList: 'On Watch List'
			},
			actions: {
				goToUserId: 'Go To User ID'
			}
		},
		wallets: {
			name: 'Wallets',
			lockReason: 'Please enter a reason',
			terminateReason: 'Please enter a reason',
			fields: {
				walletId: 'Wallet ID',
				subsidiaryId: 'Subsidiary ID',
				creationDateTime: 'Created',
				walletType: 'Type',
				walletStatus: 'Status',
				externalReferenceId: 'External Reference'
			},
			filters: {
				ownerType: 'Owner Type',
				ownerId: 'Owner ID',
				type: 'Wallet Type',
				status: 'Wallet Status',
				externalReferenceId: 'External Reference'
			},
			actions: {
				lock: 'Lock',
				unlock: 'Unlock',
				terminate: 'Terminate',
				createWalletAccount: 'Create wallet account',
				goToWalletId: 'Go to wallet ID'
			},
			aside: {
				walletAccounts: 'Go to Wallet Account List'
			},
			tabs: {
				overview: 'Overview',
				paymentInstruments: 'Payment Instruments',
				walletNotifications: 'Wallet Notifications'
			},
			labels: {
				aside: 'Related Entities',
				title: 'Wallet Details',
				wallets: 'Wallets',
				addresses: 'Addresses',
				idDocuments: 'ID Documents',
				lock: 'Lock Wallet',
				unlock: 'Unlock Wallet',
				terminate: 'Terminate Wallet',
				createWalletAccount: 'Create Wallet Account',
				inputCreateWalletAccount: 'Name:',
				goToWalletId: 'Go to wallet ID',
				walletId: 'Wallet ID'
			},
			notifications: {
				terminated: 'The wallet is now terminated.',
				locked: 'The wallet was successfully locked.',
				unlocked: 'The wallet was successfully unlocked.',
				foundWallet: 'Found the Wallet.',
				identifier: 'Identifier'
			}
		},
		walletAccounts: {
			name: 'Wallet Accounts',
			successfulCreatedMessage: 'WalletAccount created successfully.',
			fields: {
				walletId: 'Wallet ID',
				walletAccountId: 'Wallet Account ID',
				externalAccountId: 'ExtAcc#',
				accountType: 'Type',
				accountStatus: 'Status',
				accountQualifier: 'Qualifier',
				'accountBalance.balance': 'Balance',
				'accountBalance.reservedBalance': 'Reserved balance'
			},
			filter: {
				type: 'Type',
				status: 'Status',
				walletAccountQualifier: 'Qualifier',
				externalAccountId: 'Ext. Acct. ID'
			},
			labels: {
				goToWalletAccountId: 'Go to wallet account ID',
				overview: 'Wallet Account Overview',
				createInvoice: 'Create Invoice',
				asideTitle: 'Actions',
				lock: 'Lock Wallet Account',
				unlock: 'Unlock Wallet Account',
				delete: 'Delete Wallet Account',
				undelete: 'Un-Delete Wallet Account'
			},
			notifications: {
				invoiceSuccessfullyCreatedMessage: 'Invoice created successfully.',
				successfullyLocked: 'Wallet Account successfully locked.',
				successfullyUnlocked: 'Wallet Account successfully unlocked.',
				successfullyDeleted: 'Wallet Account successfully deleted.',
				successfullyUndeleted: 'Wallet Account successfully undeleted.'
			}
		},
		walletAccountItems: {
			name: 'Wallet Account Items',
			aside: {
				title: 'Actions'
			},
			links: {
				goToTransferType: 'Go To '
			}
		},
		walletNotifications: {
			name: 'Wallet Notifications',
			filter: {
				walletId: 'Wallet ID',
				fromDate: 'From',
				untilDate: 'To',
				type: 'Notification Type',
				subType: 'Notification Subtype',
				ipAddress: 'IP Address',
				ownerType: 'Owner Type',
				ownerId: 'Owner ID',
				notifierType: 'Notifier Type',
				notifierId: 'Notifier ID',
				notificationComponent: 'Component'
			},
			labels: {
				addComment: 'Add Comment',
				comment: 'Comment'
			},
			actions: {
				addComment: 'Add Comment'
			},
			notifications: {
				successfulCreatedMessage: 'Comment created successfully.'
			}
		},
		paymentInstruments: {
			name: 'Payment Instruments',
			fields: {
				paymentInstrumentId: 'ID',
				creationDateTime: 'Created',
				paymentInstrumentStatus: 'Status',
				paymentInstrumentVerificationStatus: 'Verification Status',
				paymentInstrumentType: 'Type',
				paymentInstrumentCapabilities: 'Capabilities',
				displayValue: 'Display Value',
				searchValue: 'Search Value',
				publicPaymentInstrumentInfo: {
					owner: 'Owner',
					countryCode: 'Country Code',
					bic: 'BIC',
					iban: 'IBAN',
					scheme: 'Scheme',
					maskedCardNumber: 'Masked Card Number',
					validToMonth: 'Valid To (Month)',
					validToYear: 'Valid To (Year)'
				},
			},
			filter: {
				status: 'Status',
				type: 'Type'
			},
			labels: {
				publicPaymentInstrumentInfo: 'Public information',
				goToPaymentInstrumentId: 'Go to Payment Instrument ID',
				update: {
					lock: {
						button: 'Lock',
						dialog: 'Lock Payment Instrument'
					},
					activate: {
						button: 'Activate',
						dialog: 'Activate Payment Instrument'
					},
					delete: {
						button: 'Delete',
						dialog: 'Delete Payment Instrument'
					},
					invalidate: {
						button: 'Invalidate',
						dialog: 'Invalidate Payment Instrument'
					}
				}
			},
			actions: {
				goToPaymentInstrumentId: 'Go to paymentInstrument ID'
			},
			notifications: {
				update: {
					lock: 'Payment instrument successfully locked.',
					delete: 'Payment instrument successfully deleted.',
					invalidate: 'Payment instrument successfully invalidated.',
					activate: 'Payment instrument successfully activated.'
				}
			}
		},
		paymentInstrumentDocuments: {
			name: 'Payment Instrument Documents',
			fields: {
				creationDateTime: 'Upload date',
				originalFileName: 'Filename',
				verificationDateTime: 'Verification date'
			},
			actions: {
				uploadDocument: 'Upload document',
				verify: 'Verify'
			},
			labels: {
				createPaymentInstrumentDocument: 'Create payment instrument document',
				verify: 'Verify Payment instrument document'
			},
			notifications: {
				successfullyCreatedMessage: 'Document uploaded successfully.',
				successfullyVerifiedMessage: 'Payment instrument successfully verified.'
			}
		},
		balanceTransactions: {
			name: 'Balance Transactions',
			fields: {
				id: 'ID',
				externalId: 'External ID',
				creationDateTime: 'Created date/time',
				cancellationDateTime: 'Cancellation date/time',
				operation: 'Operation',
				type: 'Type',
				subType: 'Subtype',
				amount: 'Amount',
				amountLC: 'Amount (LC)',
				status: 'Status',
				description: 'Description',
				transactionPayloadJson: 'Transaction Payload JSON',
				transactionOwner: 'Transaction Owner',
				walletAccountId: 'Wallet Account',
				walletAccountItemId: 'Wallet Account Item ID',
				walletAccountItemOtherPart: 'Wallet Account Item ID (other part)',
				minimumRemainingBalance: 'Minimum remaining balance',
				categoryCode: 'Category Code'
			},
			filter: {
				referencedBalanceTransactionId: 'Ref. balance tx. ID',
				otherAccountId: 'Other Account ID',
				otherAccountType: 'Other Account Type',
				transactionOwnerId: 'Tx. Owner ID',
				transactionOwnerType: 'Tx. Owner Type',
				fromDate: 'From',
				untilDate: 'Until'
			}
		},
		payments: {
			label: {
				feeAmountLC: 'Fee Amount LC'
			},
			name: 'Payments',
			actions: {
				goToPaymentId: 'Go to payment ID',
				settlePayment: 'Settle',
				paymentFailed: 'Payment failed'
			},
			labels: {
				goToPaymentId: 'Go to payment ID',
				settlePayment: 'Settle payment'
			},
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				paymentStatus: 'Status',
				amount: 'Amount',
				paymentTransactionId: 'Payment Transaction ID',
				paymentType: 'Type',
				customType: 'Custom Type',
				referencedPaymentId: 'Referenced Payment ID',
				paymentMethod: 'Payment Method',
				paymentCategoryCode: 'Payment Category Code',
				feeAmount: 'Fee Amount',
				feeAmountLC: 'Fee Amount (LC)',
				description: 'Description',
				walletId: 'Wallet ID',
				walletAccountId: 'Wallet Account ID',
				walletAccountItemId: 'Wallet Account Item ID',
				walletAccountItemDisplayId: 'Wallet Account Item Display ID',
				paymentFlowType: 'Payment Flow Type',
				paymentInstrumentId: 'Payment Instrument ID',
				paymentOwner: 'Payment Owner',
				paymentSessionId: 'Payment Session ID',
				paymentSettlementStatus: 'Payment Settlement Status',
				manualSettlementComment: 'Manual Settlement Comment',
				paymentReversalTransactionId: 'Reversal Transaction ID'
			},
			notifications: {
				successfullySettled: 'Payment successfully settled.'
			}
		},
		invoices: {
			name: 'Invoices',
			fields: {
				walletAccountId: 'Wallet Account ID',
				invoiceAmount: 'Invoice Amount',
				invoiceCurrency: 'Invoice Currency',
				systemAccountId: 'System Account ID',
				vatDefinitionId: 'VAT ID',
				description: 'Description',
				customType: 'Custom Type'
			},
			filter: {
				walletAccountId: 'Wallet Account ID',
				invoiceOwnerId: 'Owner ID',
				invoiceOwnerType: 'Owner Type',
				invoiceCustomType: 'Custom Type',
				systemAccountId: 'System Account ID',
				invoiceType: 'Type',
				invoiceStatus: 'Status'
			},
			labels: {
				confirmButton: 'Confirm'
			},
			notifications: {
				confirmed: 'Invoice successfully confirmed.'
			}
		},
		accountingAccounts: {
			name: 'Accounting Accounts',
			links: {
				itemList: 'Accounting Account Items',
				transferList: 'Accounting Account Transfers'
			},
			labels: {
				accountBalance: 'Account Balance',
				goToAccountingAccountId: 'Go to accounting account ID',
				updateTrafficTypeWarning: 'An update to the traffic type may have an impact on performance and responsiveness of the system. Please be very aware of the consequences of your action!',
			},
			fields: {
				id: 'Account ID',
				subsidiaryId: 'Subsidiary',
				'accountType.accountTypeCode': 'Type',
				'accountType.description': 'Description',
				owner: 'Owner',
				currencyCode: 'Currency',
				qualifier: 'Qualifier',
				trafficType: 'Traffic Type',
				accountBalance: 'Balance',
			},
			filter: {
				ownerType: 'Owner Type',
				ownerId: 'Owner ID',
				accountTypeCode: 'Type',
				currencyCode: 'Currency',
				accountQualifier: 'Qualifier',
				subsidiaryId: 'Subsidiary'
			},
			actions: {
				goToAccountingAccountId: 'Go to accounting account ID',
				goToAccountingAccountItems: 'Accounting account items',
				goToAccountingAccountTransfers: 'Accounting account transfers',
				updateTrafficType: 'Update traffic type',
			},
			notifications: {
				trafficTypeUpdated: 'Traffic type successfully updated.'
			}
		},
		accountingAccountItems: {
			name: 'Accounting Account Items',
			filter: {
				accountingAccount: 'Accounting Account'
			},
			fields: {
				amount: 'Amount',
				balance: 'Balance',
				turnover: 'Turnover',
				amountLC: 'Amount (Lead Currency)',
				balanceLC: 'Balance (Lead Currency)',
				turnoverLC: 'Turnover (Lead Currency)',
				openAmount: 'Open Amount'
			}
		},
		accountingAccountTransfers: {
			name: 'Accounting Account Transfers',
			filter: {
				ownerType: 'Owner Type',
				ownerId: 'Owner ID',
				fromAccountId: 'From Account Id',
				toAccountId: 'To Account Id',
				fromDate: 'From Date',
				untilDate: 'Until Date',
				transferType: 'Transfer Type',
				transferQualifier: 'Transfer Qualifier',
				transferStatus: 'Transfer Status'
			},
			links: {
				goToTransferType: 'Go To '
			},
			fields: {
				id: 'ID',
				fromAccountId: 'From Account ID',
				toAccountId: 'To Account ID',
				owner: 'Owner',
				creationDateTime: 'Created',
				amount: 'Amount',
				transferType: 'Type',
				description: 'Description',
				transferQualifier: 'Qualifier',
				transferStatus: 'Status'
			},
			labels: {
				aside: 'Related Entities',
				amount: 'Amount',
				balance: 'Balance',
				turnover: 'Turnover',
				amountLC: 'Amount (Lead Currency)',
				amountLCShort: 'Amount (LC)',
				balanceLC: 'Balance (Lead Currency)',
				turnoverLC: 'Turnover (Lead Currency)',
				openAmount: 'Open Amount',
				goToAccountingAccountTransferId: 'Go to accounting account transfer ID'
			},
			actions: {
				goToAccountingAccountTransferId: 'Go to accounting account transfer ID'
			}
		},
		paymentTransactions: {
			name: 'Payment Transactions',
			fields: {
				creationDateTime: 'Created',
				referenceTransactionId: 'Ref. Transaction',
				businessContractId: 'Business Contract',
				'gatewayIdentifier.name': 'Gateway',
				paymentTransactionStatus: 'Status',
				paymentTransactionType: 'Type',
				paymentInstrumentPublicId: 'Payment instrument',
				paymentGatewayIdentifier: 'Gateway identifier',
				paymentGatewayVersion: 'Gateway version',
				'paymentData.firstName': 'First name',
				'paymentData.lastName': 'Last name',
				'paymentData.email': 'Email',
				'paymentData.phoneNumber': 'Phone number',
				'paymentData.amount': 'Amount',
				'paymentData.bankStatement': 'Bank statement',
				'paymentData.mcc': 'MCC',
				'paymentData.externalPaymentId': 'External payment ID',
				'paymentData.paymentContext': 'Payment context',
				'paymentData.paymentInstrumentStatus': 'Payment instrument status',
				'paymentData.billingAddress': 'Billing address',
				'paymentData.shippingAddress': 'Shipping address',
				'paymentData.riskLevel': 'Risk level',
				'paymentData.paRes': 'PARes',
				'paymentData.merchantData': 'Merchant data',
				'paymentData.externalTransactionDate': 'External transaction date',
				'paymentData.subsidiaryId': 'Subsidiary Id',
				'paymentData.userIpAddress': 'IP Address',
				'paymentData.userLanguage': 'User Language',
				'ownerType': 'Owner Type',
				'ownerId': 'Owner ID',
				owner: 'Owner'
			},
			labels: {
				goToPaymentTransactionId: 'Go to payment transaction ID',
				goToPayment: 'Go to payment'
			},
			actions: {
				goToPaymentTransactionId: 'Go to payment transaction ID',
				goToPayment: 'Go to payment'
			},
			titles: {
				overview: 'Overview',
				requestResponse: 'Request / Response',
				transactionData: 'Transaction Data'
			}
		},
		paymentTransactionLogs: {
			name: 'Payment Transaction Logs',
			fields: {
				requestId: 'Request ID',
				authorizationId: 'Authorization ID'
			}
		},
		paymentFailures: {
			name: 'Payment Failures',
			fields: {
				creationDateTime: 'Created'
			},
			filter: {
				type: 'Type',
				status: 'Status'
			},
			actions: {
				confirm: 'Confirm',
				startDisputeProcess: 'Start dispute process',
				expirePaymentFailure: 'Expire payment failure',
				disputeWon: 'Dispute won',
				disputeLost: 'Dispute lost'
			}
		},
		paymentApprovals: {
			name: 'Payment Approvals',
			fields: {
				creationDateTime: 'Created',
				expiryDateTime: 'Expires'
			}
		},
		unmatchedPayments: {
			name: 'Unmatched Payments',
			fields: {
				creationDateTime: 'Created',
				unmatchedPaymentStatus: 'Status',
				resolveDateTime: 'Resolved',
				resolver: 'Resolved by',
				'paymentTransactionData.amount': 'Amount',
				'paymentTransactionData.subject': 'Subject',
				'paymentTransactionData.owner': 'Owner',
				'paymentTransactionData.date': 'Date',
				'paymentTransactionData.oldStatus': 'Old Status',
				'paymentTransactionData.newStatus': 'New Status',
				'paymentTransactionData.externalPaymentId': 'External Payment ID',
				'paymentTransactionData.externalTransactionId': 'External Transaction ID',
				'paymentTransactionData.mcc': 'MCC',
				'paymentTransactionData.paymentMethodName': 'Payment Method Name',
				'paymentTransactionData.paymentContext': 'Payment Context',
				'paymentTransactionData.publicPaymentInstrumentId': 'Payment Instrument ID',
				'paymentTransactionData.publicTransactionId': 'Transaction ID'
			},
			filters: {
				paymentTransactionId: 'ID',
				unmatchedPaymentStatus: 'Status',
				oldStatus: 'Old Status',
				newStatus: 'New Status',
				resolverType: 'Resolver Type',
				resolverId: 'Resolver Id'
			},
			actions: {
				goToUnmatchedPaymentId: 'Go to unmatched payment ID',
				resolve: 'Resolve',
				cancel: 'Cancel',
				ignore: 'Ignore'
			},
			labels: {
				goToUnmatchedPaymentId: 'Go to unmatched payment ID',
				resolve: 'Resolve unmatched payment',
				cancel: 'Cancel',
				ignore: 'Ignore'
			},
			notifications: {
				successfullyResolved: 'The payment was resolved successfully.',
				successfullyIgnored: 'The payment was ignored successfully.',
				successfullyCancelled: 'The payment was cancelled successfully.'
			}
		},
		businessContracts: {
			name: 'Business Contracts',
			fields: {
				id: 'ID',
				status: 'Status',
				subsidiaryId: 'Subsidiary ID',
				type: 'Type',
				paymentMethodName: 'Payment Method',
				qualifier1: 'Qualifier 1',
				qualifier2: 'Qualifier 2',
				comment: 'Comment',
				supportsAuthorize: 'Supports Authorize',
				supportsPreauthorize: 'Supports Preauthorize',
				supportsCapture: 'Supports Capture',
				supportsCredit: 'Supports Credit',
				supportsRefund: 'Supports Refund',
				supportsReverse: 'Supports Reversal'
			},
			labels: {
				title: 'Business Contract Details',
				createBusinessContractParameter: 'Create business contract parameter',
				activateButton: 'Activate',
				deactivateButton: 'Deactivate'
			},
			notifications: {
				deactivated: 'Business contract successfully deactivated.',
				activated: 'Business contract successfully activated.'
			}
		},
		businessContractParameters: {
			name: 'Business Contract Params',
			actions: {
				createBusinessContractParameter: 'Create'
			},
			notifications: {
				successfullyCreatedMessage: 'Business contract parameter successfully created.',
				successfullyUpdatedMessage: 'Business contract parameter successfully updated.'
			},
			labels: {
				title: 'Business Contract Parameters',
				name: 'Name',
				value: 'Value',
				secure: 'This parameter is sensitive and should be displayed as a masked value.'
			}
		},
		businessContractRoutes: {
			name: 'Business Contract Route',
			fields: {
				businessContractId: 'Business Contract ID',
				countryCode: 'Country',
				currencyCode: 'Currency',
				mccFrom: 'MCC from',
				mccTo: 'MCC to',
				userVerificationLevel: 'User verification level',
				paymentContext: 'Payment context',
				comment: 'Comment'
			},
			labels: {
				title: 'Business Contract Routes',
				disableButton: 'Disable',
				enableButton: 'Enable'
			},
			notifications: {
				disabled: 'Business contract route successfully disabled.',
				enabled: 'Business contract route successfully enabled.'
			}
		},
		binGroups: {
			name: 'BIN Groups',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				groupName: 'Group Name',
				binRanges: 'BIN ranges',
				groupDescription: 'Description'
			},
			labels: {
				groupName: 'Group Name',
				binRanges: 'BIN ranges',
				groupDescription: 'Description',
				createBinGroup: 'Create BIN group',
				formatHint:
					'Valid inputs are comma separated 6-figure numbers or ranges. ' +
					'Both ends are inclusive. E.g.<ul><li>100000</li><li>100000-199999</li><li>100000-199999,300000-399999,666666</li></ul>'
			},
			actions: {
				createBinGroup: 'Create'
			},
			notifications: {
				successfullyUpdatedMessage: 'BIN group successfully updated.',
				successfullyCreatedMessage: 'BIN group successfully created.'
			}
		},
		mt940Files: {
			name: 'MT940 File |||| MT940 Files',
			fields: {
				creationDateTime: 'Created',
				statusDateTime: 'Processed',
				sourceFilePath: 'Source Path',
				status: 'Status',
				fileName: 'Name',
				statusText: 'Status Description'
			},
			actions: {
				uploadFile: 'Upload'
			},
			titles: {
				fileRecords: 'File Records'
			},
			labels: {
				editMT940File: 'Edit File',
				statusCreated: 'Created',
				statusSuccess: 'Successful',
				statusFailed: 'Failed',
				statusManual: 'ManuallyReviewed',
				statusComment: 'Comment',
				uploadFile: 'Upload a MT940 file'
			},
			notifications: {
				successfullyUpdatedMessage: 'File successfully updated.',
				successfullyUploadedMessage: 'File successfully uploaded.'
			}
		},
		mt940FileRecords: {
			name: "MT940 File Record |||| MT940 File Records",
			fields: {
				creationDateTime: 'Created',
				statusDateTime: 'Processed',
				status: 'Status',
				valuta: 'Valuta',
				amount: "Amount",
				sourceBankAccountOwner: 'Source Account Owner',
				sourceBankAccountNumber: 'Source Account Number',
				bankAccount: 'Bank Account'
			},
			labels:{
				editMT940FileRecord: 'Edit File Record',
				statusCreated: 'Created',
				statusSuccess: 'Successful',
				statusFailed: 'Failed',
				statusManual: 'ManuallyReviewed',
				statusComment: 'Comment'
			},
			notifications: {
				successfullyUpdatedMessage: 'File Record successfully updated.'
			}
		},
		subsidiaries: {
			name: 'Subsidiaries'
		},
		currencies: {
			name: 'Currencies'
		},
		vatDefinitions: {
			name: 'VAT Definitions',
			filter: {
				vatType: 'VAT Type',
				countryCode: 'Country Code',
				validFrom: 'Valid from',
				validUntil: 'Valid until'
			},
			fields: {
				vatType: 'VAT Type',
				vatRate: 'VAT Rate',
				countryCode: 'Country Code',
				validFrom: 'Valid from',
				description: 'Description'
			}
		},
		blackWhiteLists: {
			name: 'Black-/White-Lists',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				blackWhiteListType: 'Type',
				key: 'Key',
				name: 'Name'
			},
			labels: {
				createBlackWhiteListItem: 'Create black-/white-list item',
				editBlackWhiteListItem: 'Edit black-/white-list item',
				blackList: 'Blacklist',
				whiteList: 'Whitelist'
			},
			actions: {
				createBlackWhiteListItem: 'Create'
			}
		},
		blackWhiteListItems: {
			name: 'Black-/White-List Items',
			fields: {
				value: 'Value',
				description: 'Description',
				active: 'Active'
			},
			labels: {
				value: 'Value',
				description: 'Description',
				active: 'Active',
				editBlackWhiteListItem: 'Edit Black-/White-List Item'
			},
			notifications: {
				successfullyCreatedMessage: 'Black white list item successfully created.',
				successfullyUpdatedMessage: 'Black white list item successfully updated.'
			}
		},
		feeGroups: {
			name: 'Fee Groups',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				subsidiaryId: 'Subsidiary',
				description: 'Description'
			}
		},
		feeDefinitions: {
			name: 'Fee Definitions',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				subsidiaryId: 'Subsidiary',
				feeGroupId: 'Fee Group',
				customType: 'Custom Type',
				feeType: 'Fee Type',
				vatType: 'VAT Type',
				feeContext: 'Fee Context',
				walletCountry: 'Wallet Country',
				walletType: 'Wallet Type',
				userVerificationLevel: 'User Verification Level',
				feeCurrency: 'Fee Currency',
				'validFromAmount.amount': 'Valid from amount',
				'validUntilAmount.amount': 'Valid until amount',
				validFromAmount: 'Valid from amount',
				validUntilAmount: 'Valid until amount',
				validFrom: 'Valid from',
				validUntil: 'Valid until',
				'baseAmount.amount': 'Base amount',
				'minAmount.amount': 'Min. amount',
				'maxAmount.amount': 'Max. amount',
				baseAmount: 'Base amount',
				minAmount: 'Min. amount',
				maxAmount: 'Max. amount',
				rate: 'Rate',
				amountGranularity: 'Amount granularity',
				paymentMethod: 'Payment method',
				description: 'Description'
			}
		},
		limitGroups: {
			name: 'Limit Groups',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				subsidiaryId: 'Subsidiary',
				description: 'Description'
			}
		},
		limitDefinitions: {
			name: 'Limit Definitions',
			filter: {
				limitGroup: 'Group',
				limitContext: 'Context',
				limitCurrency: 'Currency',
				walletCountry: 'Wallet Country',
				walletType: 'Wallet Type',
				userVerificationLevel: 'User Verification Level',
				enabled: 'Enabled',
				validFrom: 'Valid from',
				validUntil: 'Valid until',
				limitType: 'Type',
				limitCurrencyType: 'Currency Type',
				limitSubtype: 'Subtype',
				limitScope: 'Scope',
				limitPaymentMethod: 'Payment Method',
				limitPeriod: 'Period',
				limitOperation: 'Operation',
				limitPeriodAmount: 'Period Amount',
				customType: 'Custom Type'
			},
			fields: {
				limitGroup: 'Group',
				limitContext: 'Context',
				limitCurrency: 'Currency',
				walletCountry: 'Wallet Country',
				walletType: 'Wallet Type',
				userVerificationLevel: 'User Verification Level',
				enabled: 'Enabled',
				validFrom: 'Valid from',
				validUntil: 'Valid until',
				limitType: 'Type',
				limitCurrencyType: 'Currency Type',
				limitSubtype: 'Subtype',
				limitScope: 'Scope',
				limitPaymentMethod: 'Payment Method',
				limitPeriod: 'Period',
				limitOperation: 'Operation',
				limitPeriodAmount: 'Period Amount',
				customType: 'Custom Type',
				limitValue: 'Value',
				'limitValueAmount.amount': 'Amount',
				'limitValueAmount.currency': 'Currency'
			}
		},
		purchases: {
			name: 'Purchases',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				shopConfigurationId: 'Shop Configuration',
				purchaseType: 'Type',
				purchaseStatus: 'Status',
				consumerAmount: 'Consumer Amount',
				refundedAmount: 'Refunded Amount',
				consumerWalletId: 'Consumer Wallet',
				consumerWalletAccountId: 'Consumer Wallet Account',
				description: 'Description',
				customType: 'Custom Type',
				refundedAmountLC: 'Refunded Amount (LC)',
				loyaltyCreditAmount: 'Loyalty Credit Amount',
				loyaltyCreditAmountLC: 'Loyalty Credit Amount (LC)',
				consumerExchangeRate: 'Exchange Rate',
				consumerLoyaltyCreditAmount: 'Loyalty Credit Amount',
				consumerRefundedAmount: 'Refunded Amount',
				walletAccountId: 'Merchant Wallet Account',
				walletId: 'Merchant Wallet',
				merchantAmount: 'Amount',
				merchantExchangeRate: 'Exchange Rate',
				merchantLoyaltyCreditAmount: 'Loyalty Credit Amount',
				merchantRefundedAmount: 'Refunded Amount',
				purchaseSettlementStatus: 'Settlement Status',
				manualSettlementComment: 'Manual Settlement Comment',
			},
			filter: {
				shopConfigurationId: 'Shop Configuration',
				purchaseType: 'Type',
				purchaseStatus: 'Status',
				fromDate: 'From',
				untilDate: 'Until',
			},
		},
		shopConfigurations: {
			name: 'Shop Configurations',
			fields: {
				shopConfigurationId: 'ID',
				creationDateTime: 'Created',
				shopConfigurationStatus: 'Status',
				name: 'Name',
				currencyCode: 'Currency',
				shopCategoryCode: 'Category Code',
				walletAccountId: 'Wallet Account',
				customType: 'Custom Type',
			},
			filter: {
				walletId: 'Wallet ID',
				walletAccountId: 'Wallet Account ID',
				shopConfigurationStatus: 'Status',
			},
			actions: {
				activate: 'Activate',
				lock: 'Lock',
			},
			notifications: {
				successfullyUpdated: 'Shop configuration successfully updated!',
			},
		},
		refunds: {
			name: 'Refunds',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				amount: 'Amount',
				refundStatus: 'Status',
				purchaseId: 'Purchase ID',
				description: 'Description',
				consumerWalletId: 'Consumer Wallet ID',
				consumerWalletAccountId: 'Consumer Wallet Account ID',
				customType: 'Custom Type',
				loyaltyCreditAmount: 'Loyalty Credit Amount',
				loyaltyCreditAmountLC: 'Loyalty Credit Amount (LC)',
				consumerAmount: 'Consumer Amount',
				consumerExchangeRate: 'Consumer Exchange Rate',
				consumerExchangeRateId: 'Consumer Exch. Rate ID',
				consumerLoyaltyCreditAmount: 'Consumer Loyalty Credit Amount',
				merchantAmount: 'Merchant Amount',
				merchantExchangeRate: 'Merchant Exchange Rate',
				merchantExchangeRateId: 'Merch. Exch. Rate ID',
				walletId: 'Merchant Wallet ID',
				walletAccountId: 'Merchant Wallet Account ID',
				merchantLoyaltyCreditAmount: 'Merchant Loyalty Credit Amount',
			},
			filter: {
				shopConfigurationId: 'Shop Configuration ID',
				purchaseId: 'Purchase ID',
				refundStatus: 'Status',
				consumerWalletId: 'Consumer Wallet ID',
				consumerWalletAccountId: 'Consumer Wallet Account ID',
				fromDate: 'From',
				untilDate: 'Until',
			},
		},
		idDocuments: {
			name: 'ID Documents',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				status: 'Status',
				originalFileName: 'Filename',
				qualifier: 'Qualifier',
				owner: 'Owner',
				fileContentType: 'File Type',
				fileSizeBytes: 'File Size',
				statusDateTime: 'Updated',
				statusText: 'Comment',
			},
			labels: {
				noPreviewPossible: 'This file cannot be previewed. Please click below to download the file.',
				downloadButton: 'Download',
			},
		},
		approvableAdminActions: {
			name: 'Approvable Admin Actions',
			fields: {
				id: 'ID',
				creationDateTime: 'Created',
				finalizeDateTime: 'Finalized',
				status: 'Status',
				initiator: 'Initiator',
				finalizer: 'Finalizer',
				request: 'Request',
				response: 'Response',
				error: 'Error',
			},
			actions: {
				approve: 'Approve',
				revoke: 'Revoke',
				decline: 'Decline',
			},
			notifications: {
				approveSuccess: 'Action successfully approved.',
				revokeSuccess: 'Action successfully revoked.',
				declineSuccess: 'Action successfully declined.',
			},
		},
	},
};

export default messages;
